import { INTERNAL_DATA, SOCIAL_LINKS } from '@/config/global-config'
import { BRAND_NAME, SCHEMA_IDS, SITE_FULL_NAME, SITE_URL, toAbsoluteUrl } from './constants'

export const buildOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': SCHEMA_IDS.organization,
  name: SITE_FULL_NAME,
  alternateName: BRAND_NAME,
  legalName: INTERNAL_DATA.legalName,
  url: SITE_URL,
  logo: {
    '@type': 'ImageObject',
    url: toAbsoluteUrl(INTERNAL_DATA.logo),
  },
  image: toAbsoluteUrl(INTERNAL_DATA.logo),
  taxID: INTERNAL_DATA.taxID,
  email: INTERNAL_DATA.email,
  telephone: INTERNAL_DATA.hotline,
  sameAs: [SOCIAL_LINKS.facebook, SOCIAL_LINKS.instagram, SOCIAL_LINKS.youtube, SOCIAL_LINKS.tiktok].filter(
    Boolean
  ),
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: INTERNAL_DATA.hotline,
      contactType: 'customer service',
      areaServed: 'VN',
      availableLanguage: ['Vietnamese', 'English'],
    },
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: INTERNAL_DATA.streetAddress,
    addressLocality: INTERNAL_DATA.addressLocality,
    addressRegion: INTERNAL_DATA.addressRegion,
    postalCode: INTERNAL_DATA.postalCode,
    addressCountry: INTERNAL_DATA.addressCountry,
  },
})
